import { createStrings } from '@utils/local';

export const vesselScheduleStrings = createStrings({
  ja: {
    no: 'NO.',
    vessel: 'VESSEL',
    callsign: 'CALL SIGN',
    voyage: 'VOYAGE',
    pol: 'POL',
    pod: 'POD',
    etd: 'ETD',
    eta: 'ETA',
    ata: 'ATA',
    atd: 'ATD',
    vesselScheduleItemsRequired: '本船スケジュールを入力してください。',
    cannotUpdateVessel: (d2dNos: string[]) =>
      `${d2dNos.join(', ')}に使用されているため、更新できませんでした。`,
    cannotUpdateVesselForAgency: (pols: string[]) =>
      `当前代理店只能编辑${pols.join(', ')}出港的船期。`,
    cannotUpdateAnyVesselForAgency: `当前代理店不能编辑船期。`,
  },
});

export const vesselScheduleWritePermissions: Partial<Record<string, string[]>> = {
  // Freightman
  FCP142: ['SHANGHAI'],
  // FC Shenzhen
  FCP2082: ['SHEKOU'],
  // FC Qingdao
  FCP88: ['QINGDAO', 'SHIDAO'],
};
